import { render, staticRenderFns } from "./AdminsContentView.vue?vue&type=template&id=772f04ce&scoped=true&lang=pug&"
import script from "./AdminsContentView.vue?vue&type=script&lang=js&"
export * from "./AdminsContentView.vue?vue&type=script&lang=js&"
import style0 from "./AdminsContentView.vue?vue&type=style&index=0&id=772f04ce&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772f04ce",
  null
  
)

export default component.exports